import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardWrap from '../components/CardWrapper';
// import config from '../components/config';
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';

// Titlecloudcompute
function WebHook() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Webhook - Serverless Application - 프라이빗 클라우드';
    }, []);
    return (
        <div className='App'>
            <NavButton option={{
                // logo: logoKube,
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061ff' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />
            {/* {Banner("Hanbiro", "Microservice architecture")} */}
            <BannerPrivateCloud />
            <Container className='main-body'>
                <Row>
                    <Col lg={3} md={12} xs={12}>
                        {!isMobile && <Sidebar />}
                    </Col>
                    <Col lg={9} md={12} xs={12} className="right-content">
                        {/* {Titlecloudcompute("Webhook")} */}
                        <BoxContent>
                            <BoxText  ><p class="typo-14">• Webhook 은 직접 선택한 URL 로 보내지는 이벤트 알림입니다.</p></BoxText>
                            <BoxText  ><p class="typo-14">• 사용자는 한 사이트에서 Event 를 트리거하여 다른 사이트의 실행 프로그램을 호출합니다.</p></BoxText>
                            <BoxText  ><p class="typo-14">• 마이크로서비스 개발 환경에서 작은 어플리케이션 간 또는 외부의 어플리케이션 간 연관된 작업을 쉽게 구성 가능하여 개발시간의 단축에 필수 기능입니다.</p></BoxText>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/webhook/webhook-1.svg")} */}
                            <ImageWrap src="https://hanbiro.com/cloud/library2/webhook/webhook-1.svg"></ImageWrap>
                            <BoxText ><p class="typo-14">외부에서 특정 이벤트가 발생시 클라이언트를 호출 (역방향 API)</p></BoxText>
                            <BoxText ><p class="typo-14">클라이언트의 호출되는 URL, 데이터가 보내지는 URL 을 Callback URL</p></BoxText>
                            <BoxText ><p class="typo-14">Hooking 의 의미 : 어떠한 액션 앞 또는 뒤에 추가로 어떤일을 하도록 하는것</p></BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {/*
                        {CardWrap("• 가격",config.tb6_header,config.tb6_content)}
                        */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">AWS 의 Webhook</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/cloud/library2/webhook/webhook-2.svg"></ImageWrap>
                        </BoxContent>


                        {/* {CardWrap(
                            "<p>• AWS 의 Webhook</p>",
                            "", 
                            "", 
                            "https://hanbiro.com/cloud/library2/webhook/webhook-2.svg"
                        )} */}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            {/* <Cloudconsult /> */}
            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color"
            }} />
        </div>
    );
};

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px; 
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default WebHook;